"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackResponse = exports.CurrentUserResponse = exports.zString = exports.OrganisationResponse = exports.Organisation = exports.User = exports.Role = exports.PlanTypes = exports.ConfigurationResponse = exports.Configuration = exports.Question = exports.Attribute = exports.AttributeKey = exports.QuestionKey = exports.TaxonomyPaths = exports.Taxonomy = exports.CompatibilitiesMetadata = exports.Location = exports.Wave = exports.AuthorizationTokens = exports.Settings = exports.Namespace = exports.Dataset = exports.Category = exports.NamespaceWithWaveCodes = exports.Region = void 0;
var zod_1 = require("zod");
exports.Region = zod_1.z.object({
    code: zod_1.z.string(),
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    area: zod_1.z.string()
});
exports.NamespaceWithWaveCodes = zod_1.z.object({
    code: zod_1.z.string(),
    wave_codes: zod_1.z.array(zod_1.z.string())
});
exports.Category = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    order: zod_1.z.number()
});
exports.Dataset = zod_1.z.object({
    code: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    base_namespace_code: zod_1.z.string(),
    categories: zod_1.z.array(exports.Category).optional(),
    depth: zod_1.z.number(),
    order: zod_1.z.number().optional()
});
exports.Namespace = zod_1.z.object({
    code: zod_1.z.string()
});
exports.Settings = zod_1.z.object({
    settings: zod_1.z.array(zod_1.z.string()).nullable()
});
exports.AuthorizationTokens = zod_1.z.object({
    access_token: zod_1.z.string(),
    access_token_expires_at: zod_1.z.string(),
    refresh_token: zod_1.z.string(),
    refresh_token_expires_at: zod_1.z.string()
});
exports.Wave = zod_1.z.object({
    accessible: zod_1.z.boolean(),
    code: zod_1.z.string(),
    date_end: zod_1.z.string(),
    date_start: zod_1.z.string(),
    id: zod_1.z.string(),
    kind: zod_1.z.string(),
    name: zod_1.z.string(),
    namespaces: zod_1.z.array(exports.Namespace)
});
exports.Location = zod_1.z.object({
    code: zod_1.z.string(),
    id: zod_1.z.string(),
    iso_code: zod_1.z.string(),
    name: zod_1.z.string(),
    accessible: zod_1.z.optional(zod_1.z.boolean()),
    region: exports.Region,
    namespaces: zod_1.z.array(exports.NamespaceWithWaveCodes)
});
exports.CompatibilitiesMetadata = zod_1.z.object({
    has_incompatibilities: zod_1.z.boolean(),
    has_compatibilities: zod_1.z.boolean()
});
exports.Taxonomy = zod_1.z.object({
    id: zod_1.z.string(),
    height: zod_1.z.number(),
    order: zod_1.z.number(),
    name: zod_1.z.string()
});
exports.TaxonomyPaths = zod_1.z.object({
    taxonomy_path: zod_1.z.array(exports.Taxonomy),
    dataset: exports.Dataset.optional()
});
exports.QuestionKey = zod_1.z.object({
    namespace_code: zod_1.z.string(),
    question_code: zod_1.z.string()
});
exports.AttributeKey = exports.QuestionKey.extend({
    datapoint_code: zod_1.z.string(),
    suffix_code: zod_1.z.string()
});
exports.Attribute = exports.AttributeKey.extend({
    question_description: zod_1.z.string(),
    question_label: zod_1.z.string(),
    datapoint_label: zod_1.z.string(),
    suffix_label: zod_1.z.string(),
    order: zod_1.z.number(),
    compatibilities_metadata: exports.CompatibilitiesMetadata
});
exports.Question = zod_1.z.object({
    namespace_code: zod_1.z.string(),
    question_code: zod_1.z.string(),
    question_label: zod_1.z.string(),
    question_description: zod_1.z.string(),
    has_suffixes: zod_1.z.boolean(),
    average_unit: zod_1.z.string(),
    accessible: zod_1.z.boolean(),
    notice: zod_1.z.string(),
    warning: zod_1.z.string(),
    knowledge_base: zod_1.z.string(),
    message: zod_1.z.string(),
    flags: zod_1.z
        .array(zod_1.z.string())
        .optional()
        .nullable(),
    taxonomy_paths: zod_1.z.array(exports.TaxonomyPaths).optional(),
    attributes: zod_1.z.array(exports.Attribute).optional()
});
exports.Configuration = zod_1.z.object({
    name: zod_1.z.string(),
    url: zod_1.z.string(),
    is_unavailable: zod_1.z.boolean()
});
exports.ConfigurationResponse = zod_1.z.object({
    application_name: zod_1.z.string(),
    configurations: zod_1.z.array(exports.Configuration),
    is_unavailable: zod_1.z.boolean(),
    feature_branch_is_valid: zod_1.z.boolean()
});
exports.PlanTypes = zod_1.z.enum(['free', 'free_reports', 'professional', 'student', 'dashboards', 'view_only', 'open_access_view_only']);
exports.Role = zod_1.z.object({
    app: zod_1.z.string(),
    role: zod_1.z.string()
});
exports.User = zod_1.z.object({
    id: zod_1.z.number().nullish(),
    external_id: zod_1.z.number().nullish(),
    email: zod_1.z.string().nullish(),
    plan_handle: exports.PlanTypes.nullish(),
    plan: zod_1.z.string().nullish(),
    admin: zod_1.z.boolean().nullish(),
    customer_flags: zod_1.z.array(zod_1.z.string()).nullish(),
    organisation_id: zod_1.z.number().nullish(),
    organisation_name: zod_1.z.string().nullish(),
    first_name: zod_1.z.string().nullish(),
    last_name: zod_1.z.string().nullish(),
    job_title: zod_1.z.string().nullish(),
    city_name: zod_1.z.string().nullish(),
    country_name: zod_1.z.string().nullish(),
    partner_deal_name: zod_1.z.string().nullish(),
    confirmed_at: zod_1.z.string().nullish(),
    saw_onboarding: zod_1.z.boolean().nullish(),
    roles: zod_1.z.array(exports.Role).nullish(),
    features: zod_1.z.array(zod_1.z.string()).nullish(),
    access_end: zod_1.z.string().nullish(),
    access_start: zod_1.z.string().nullish(),
    customer_features: zod_1.z.array(zod_1.z.string()).nullish(),
    industry: zod_1.z.string().nullish(),
    intercom_user_hash: zod_1.z.string().nullish(),
    last_platform_used: zod_1.z.string().nullish(),
    bundle_ids: zod_1.z.array(zod_1.z.number()).nullish()
});
exports.Organisation = zod_1.z.object({
    created_at: zod_1.z.string(),
    device_registration_exempt: zod_1.z.boolean(),
    enterprise_flag: zod_1.z.boolean(),
    id: zod_1.z.number(),
    name: zod_1.z.string(),
    org_type: zod_1.z.string().nullish(),
    updated_at: zod_1.z.string()
});
exports.OrganisationResponse = zod_1.z.object({
    organisation: exports.Organisation
});
exports.zString = zod_1.z.string();
exports.CurrentUserResponse = zod_1.z.object({
    data: exports.User
});
exports.TrackResponse = zod_1.z.object({});
